import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { Container, Grid, Paper } from '@material-ui/core';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import Box from '@material-ui/core/Box';
import HOCLoader from 'Components/Loader/HOCLoader';
import { FailTransactionResponse } from 'Components/Alert/FailTransactionResponse';
import { TransactionConfirmation } from 'Components/Alert/TransactionConfirmation';
import {
    PLEASE_PROVIDE_VALID,
    PLEASE_SELECT_VALID
} from 'Components/Helper/Messages';
import { AutoCompleteTextView } from 'Components/Inputes/AutoCompleteTextView';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
import RechargeIcon from 'Components/SvgButtons/RechargeIcon';
import ResetIcon from 'Components/SvgButtons/ResetIcon';
import {
    MerchantOnboarding as MERCHANT_ONBOARDING,
    MerchantOnboardingStatus as MERCHANT_ONBOARDING_STATUS,
    SelectState as STATE_SELECT
} from 'Components/Api/PaysprintPaytmAEPSAPI';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import usePosition from 'Components/Posistion';
const CustomContainer = HOCLoader(Container);

export const PaysprintPaytmOnboarding = () => {
    const history = useHistory();
    const formRef = useRef();
    const classes = commonStyle();
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');

    const [isAlertErrorOpen, setIsAlertErrorOpen] = useState(false);
    const [Message, setMessage] = useState('');
    const [status, setStatus] = useState('PROCESS');
    const Mobile = localStorage.getItem('MobileNumber');
    const PANNo = localStorage.getItem('PANNo');
    const { latitude, longitude, error } = usePosition();
    const [stateList, setStateList] = useState([]);
    const [stateDefault, setStateDefault] = useState({
        Statecode: '',
        Statename: 'Select State'
    });

    const [formObj, setFormObj] = useState({
        PanNumber: PANNo,
        MobileNumber: Mobile,
        Latitude: latitude,
        Longitude: longitude,
        State: stateDefault
    });

    const validationSchema = Yup.object({
        State: Yup.object()
            .nullable(PLEASE_SELECT_VALID + 'state')
            .required(PLEASE_SELECT_VALID + 'state')
            .shape({
                Statecode: Yup.string()
                    .nullable(PLEASE_SELECT_VALID + 'state')
                    .required(PLEASE_SELECT_VALID + 'state')
            }),

        PanNumber: Yup.string()
            .length(10, 'Must be 10 digit')
            .required(PLEASE_PROVIDE_VALID + 'pan number'),

        MobileNumber: Yup.string()
            .length(10, 'Must be 10 digit')
            .required(PLEASE_PROVIDE_VALID + 'number')
    });
    const reset = () => {
        setStateDefault({
            Statecode: '',
            Statename: 'Select State'
        });
        setFormObj({
            PanNumber: '',
            MobileNumber: '',
            Latitude: latitude,
            Longitude: longitude
        });
    };

    const SubmitHandle = async (values, { resetForm }) => {
        setIsError(false);
        setResponseMessage('');
        setLoading(true);

        var request = {
            PanNumber: values.PanNumber,
            MobileNumber: values.MobileNumber,
            Statecode: values.State.Statecode,
            Latitude: latitude,
            Longitude: longitude
        };

        var requestObj = JSON.stringify(request);

        var response = await MERCHANT_ONBOARDING(requestObj);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();
        setSeverity('success');
        var data = JSON.parse(response.data);
        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(data.Message);

            setStatus('FAILURE');
            setMessage(data.Message);
            setIsAlertErrorOpen(true);
            return;
        }

        if (data.Status === 'SUCCESS') {
            setIsError(true);
            setSeverity('success');
            setResponseMessage(data.Message);
            history.push('/PSPAEPS');
            return;
        }
        setIsError(true);
        setSeverity('error');
        setResponseMessage(data.Message);
        return;
    };

    const MerchantStatus = async () => {
        setLoading(true);
        const response = await MERCHANT_ONBOARDING_STATUS();
        setLoading(false);
        if (!response.isAuthorized) {
            LOGOUT();
        }
        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
            setStatus('FAILURE');
            setMessage(response.data);
            setIsAlertErrorOpen(true);
        }
        var data = JSON.parse(response.data);

        if (data.Message === 'Onboarding complete') history.push('/PSPAEPS');

        setResponseMessage(data.Message);
        setIsError(true);
    };

    useEffect(() => {
        MerchantStatus();
        selectState();
    }, []);

    const selectState = async () => {
        setLoading(true);
        const response = await STATE_SELECT();
        setLoading(false);
        if (!response.isAuthorized) {
            LOGOUT();
        }
        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);

            setStatus('FAILURE');
            setMessage(response.data);
            setIsAlertErrorOpen(true);
        }

        var data = JSON.parse(response.data);
        let objWithSelectAll = [stateDefault, ...data];

        setStateList(objWithSelectAll);
    };

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObj}
                validationSchema={validationSchema}
                onSubmit={SubmitHandle}
                resetForm={formObj}
            >
                {({ setFieldValue }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                        >
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Form>
                                    <Grid item xs={12} sm={12}>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={1}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <Field
                                                        component={
                                                            AutoCompleteTextView
                                                        }
                                                        defaultValue={
                                                            stateDefault
                                                        }
                                                        SubFieldName="Statecode"
                                                        FieldName="State"
                                                        name="State"
                                                        onSearchCallback={(
                                                            text
                                                        ) => {}}
                                                        onCustomCallback={(
                                                            name,
                                                            value
                                                        ) => {
                                                            setFieldValue(
                                                                'Statecode',
                                                                value.Statecode
                                                            );

                                                            setFieldValue(
                                                                'Statename',
                                                                value.Statename
                                                            );

                                                            setStateDefault({
                                                                Statecode:
                                                                    value.Statecode,
                                                                Statename:
                                                                    value.Statename
                                                            });
                                                        }}
                                                        options={stateList}
                                                        getOptionLabel={(
                                                            option
                                                        ) => option.Statename}
                                                        getOptionSelected={(
                                                            option,
                                                            value
                                                        ) =>
                                                            option.Statename ===
                                                            value.Statename
                                                        }
                                                        textFieldProps={{
                                                            label: 'State'
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="PanNumber"
                                                        name="PanNumber"
                                                        length="10"
                                                        placeholder="Pan Number"
                                                        title="PanNumber"
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialNumberField
                                                        label="Mobile Number"
                                                        name="MobileNumber"
                                                        icon="mobile"
                                                        placeholder="Mobile Number"
                                                        title="Mobile Number"
                                                        length="10"
                                                        typed_length={1}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                        <Grid className={classes.footerGrid}>
                                            <Box
                                                className={classes.flexReverse}
                                            >
                                                <div
                                                    className={
                                                        classes.SubmitWrapper
                                                    }
                                                >
                                                    <div className="container">
                                                        <div className="row">
                                                            <div className="col-md-5">
                                                                <SecondaryButton
                                                                    disabled={
                                                                        loading
                                                                    }
                                                                    endIcon={
                                                                        <ResetIcon />
                                                                    }
                                                                    title="Reset"
                                                                    onClick={() => {
                                                                        reset();
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="col-md-7">
                                                                <PrimaryButton
                                                                    title="Proceed"
                                                                    disabled={
                                                                        loading
                                                                    }
                                                                    endIcon={
                                                                        <RechargeIcon />
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Form>
                            </Grid>
                        </Grid>
                    );
                }}
            </Formik>

            {isAlertErrorOpen && (
                <FailTransactionResponse
                    isOpen={isAlertErrorOpen}
                    title={status}
                    Message={Message}
                    OkButtonClick={(request) => {
                        setIsAlertErrorOpen(false);
                    }}
                />
            )}

            {isAlertOpen && (
                <TransactionConfirmation
                    isOpen={isAlertOpen}
                    title="AEPS"
                    message="Are you sure to do onboarding?"
                    request={confirmAlertRequest}
                    positiveButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                />
            )}
        </CustomContainer>
    );
};
